"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Button = _interopRequireDefault(require("../Button"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Grid = _interopRequireDefault(require("../Grid"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var VR = _styledComponents.default.div.withConfig({
  displayName: "Controls__VR",
  componentId: "dxa0jq-0"
})(["background-color:", ";height:", ";width:1px;"], (0, _toColorString.default)(_color.default.opacity.charcoal15), (0, _rem.default)(_spacing.default.base * 2));

function Controls(props) {
  var collapseAll = props.collapseAll,
      expandAll = props.expandAll,
      controls = props.controls;
  var translate = (0, _useTranslations.default)();
  var showControls = controls !== 'hide' && (Boolean(collapseAll) || Boolean(expandAll));
  var buttonsDisabled = controls === 'disabled';

  if (showControls) {
    return _react.default.createElement(_Grid.default.Row, {
      alignment: "end"
    }, _react.default.createElement(_Flex.default, {
      padding: 1,
      alignItems: "center"
    }, _react.default.createElement(_Flex.default, {
      paddingX: 1
    }, _react.default.createElement(_Button.default, {
      onClick: collapseAll,
      size: "small",
      text: translate(undefined, 'accordion.collapseAll'),
      type: "button",
      variant: "ghost",
      disabled: buttonsDisabled || !collapseAll
    })), _react.default.createElement(VR, null), _react.default.createElement(_Flex.default, {
      paddingX: 1
    }, _react.default.createElement(_Button.default, {
      onClick: expandAll,
      size: "small",
      text: translate(undefined, 'accordion.expandAll'),
      type: "button",
      variant: "ghost",
      disabled: buttonsDisabled || !expandAll
    }))));
  }

  return null;
}

var _default = Controls;
exports.default = _default;